import { render, staticRenderFns } from "./OtpsSummary.vue?vue&type=template&id=3c8eef1b&"
import script from "./OtpsSummary.vue?vue&type=script&lang=js&"
export * from "./OtpsSummary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports